import { useLocation } from "react-router-dom";
import NavBar from "./layouts/NavBar";
import useCookies from "./hooks/useCookies";
import ApprovalBlockModal from "./components/common/ApprovalBlockModal";
import Header from "./layouts/Header";

const Layout = ({ children }) => {

  const location = useLocation();

  const hideMenuOnPages = [
    "/",
    "/forgot-password",
    "/pdf-summary",
    "/pdf-detail",
    "/pdf-order-summary",
    "/pdf-order-detail",
    "/pdf-summary",
    "/pdf-detail"
  ];

  const { getCookie } = useCookies();

  const token = localStorage.getItem("token") || sessionStorage.getItem("token");

  const isAuthenticated = !!token;
  const shouldHideLayout = hideMenuOnPages.includes(location.pathname);

  return (
    <div>
      {isAuthenticated && !shouldHideLayout && <NavBar />}

      {isAuthenticated && !shouldHideLayout && <ApprovalBlockModal />}

      {isAuthenticated && !shouldHideLayout && <Header />}

      <div className={isAuthenticated && !shouldHideLayout ? "main-content" : ""}>

        {children}
      </div>
    </div>
  );
};

export default Layout;